import {ConversationType} from '../../../models/mongoose/MessageModel/enum/ConversationType'
import {THREAD_CONVERSATION_TYPES} from '../constants/threadConversationTypes'

export function isThreadConversationType(conversationType: ConversationType): boolean {
  return THREAD_CONVERSATION_TYPES.includes(conversationType)
}
